import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { HashRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { ServerStatusProvider } from "./context/ServerStatusProvider";
import { AlertProvider } from "./context/AlertProvider";
import { store } from "./store";
import { ClinicThemeProvider } from "./theme";

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);

root.render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <AuthProvider>
          <ClinicThemeProvider>
            <ServerStatusProvider>
              <AlertProvider>
                <Routes>
                  <Route path="/*" element={<App />} />
                </Routes>
              </AlertProvider>
            </ServerStatusProvider>
          </ClinicThemeProvider>
        </AuthProvider>
      </Provider>
    </HashRouter>
  </React.StrictMode>
);
